import { Col, Row } from "react-bootstrap";
import arc1 from "../../../assets/img/Article1.jpg";
import profileIcon from "../../../assets/img/safarioperator.png";
import Modal from "react-bootstrap/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";

import { FaRegBookmark, FaRegComment, FaRegHeart, FaRegPaperPlane } from "react-icons/fa";

function SeeCommentsModal({ show, handleClose,feedData }) {

  return (
    <>
      <Modal show={show} onHide={handleClose} size="xl" centered>
        <Modal.Body className="m-0 p-0">
          <Row className="gx-0">
            <Col xs={6}>
              <div className="h-100">
                <img
                  src={arc1}
                  alt=""
                  className="w-100 h-100 object-fit-cover"
                />
              </div>
            </Col>
            <Col xs={6} className="pe-0">
              <Row className="gx-0">
                <Col xs={12} className="px-4 mb-3 border-bottom">
                  <div className="py-3 d-flex align-items-center justify-content-between ">
                    <div className="userProfileParent d-flex align-items-center gap-2">
                      <div className="useProfile p-1 d-flex align-items-center justify-content-center">
                        <Link to="">
                          <img
                            src={profileIcon}
                            alt=""
                            className="w-100 h-100 object-fit-cover"
                          />
                        </Link>
                      </div>
                      <div className="userName d-flex align-items-center gap-2">
                        <Link to="" className="userMain text-dark">
                          walkintothewild.in_019
                        </Link>
                      </div>
                    </div>
                    <div className="followBtn d-flex align-items-center gap-3">
                      <div className="dotIcon">
                        <Link to="" className="">
                          <FontAwesomeIcon
                            icon={faEllipsisV}
                            style={{ fontSize: "22px", color: "#000" }}
                          />
                        </Link>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col xs={12} className="px-4">
                  <div className="comentertrsParent" style={{height:'400px'}}>
                    <div className="himselfProfile">
                      <div className="userProfileParent d-flex align-items-center gap-2">
                        <div className="useProfile p-1 d-flex align-items-center justify-content-center">
                          <Link to="">
                            <img
                              src={profileIcon}
                              alt=""
                              className="w-100 h-100 object-fit-cover"
                            />
                          </Link>
                        </div>
                        <div>
                          <div className="userName d-flex align-items-center gap-2">
                            <Link to="" className="userMain text-dark">
                              walkintothewild.in_019
                            </Link>
                          </div>
                          <div className="hours">
                            <span>2 hour ago</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="">
                      
                    </div>
                  </div>
                </Col>
                <Col xs={12} className="px-4 mb-3">
                  <div className="socialIconsMAin d-flex justify-content-between">
                    <div className="icons d-flex gap-3">
                      <Link to="">
                        <FaRegHeart className="iKon" />{" "}
                      </Link>
                      <Link to="">
                        <FaRegComment className="iKon" />{" "}
                      </Link>
                      <Link to="">
                        <FaRegPaperPlane className="iKon" />
                      </Link>
                    </div>
                    <div className="icons">
                      <Link to="">
                        <FaRegBookmark className="iKon" />
                      </Link>
                    </div>
                  </div>
                </Col>
                <Col lg={12} className="px-4 pb-3 border-bottom">
                  <div className="likesCounter">
                    <Link to="" className="likes">
                      216,00 likes
                    </Link>
                  </div>
                  <div className="hours">
                    <span>2 hour ago</span>
                  </div>
                </Col>
                <Col xs={12}>
                  <div className="addComments position-relative">
                    <input
                      type="text"
                      placeholder="Add a comment..."
                      className="commentsIpnut w-100 ps-3"
                    />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default SeeCommentsModal;
